module.exports = __webpack_public_path__ + "img/call_bot.6570f982.png";